module.exports = __webpack_public_path__ + "static/room3-598a6871dd533b27c88ba81d72424ab7.jpg";